import React, { FC } from 'react'
import NewRepContainer from 'containers/Rep/NewRep'

const NewRepPage: FC = () => <NewRepContainer />

export default NewRepPage
